interface EnvConfig {
  apiUrl: string;
  /** Server-side API base (Docker-friendly). Falls back to apiUrl. */
  serverApiUrl: string;
  authUrl: string;
  authSecret: string;
  nodeEnv: string;
}

const getEnvConfig = (): EnvConfig => {
  const apiUrl = process.env.NEXT_PUBLIC_API_URL;
  const serverApiUrl =
    process.env.INTERNAL_API_URL || process.env.NEXT_PUBLIC_API_URL;
  const authUrl = process.env.NEXTAUTH_URL;
  const authSecret = process.env.NEXTAUTH_SECRET;
  const nodeEnv = process.env.NODE_ENV;
  if (!apiUrl || !authUrl || !authSecret) {
    throw new Error('Missing required environment variables');
  }
  return {
    apiUrl,
    serverApiUrl: serverApiUrl as string,
    authUrl,
    authSecret,
    nodeEnv: nodeEnv || 'development',
  };
};

export const envConfig = getEnvConfig();
